import type { FC } from 'react';
import { useUserContext } from 'src/common/providers/UserProvider';
import Avatar from '../Avatar';
import ComponentWrapper from '../NestedMenu/ComponentWrapper';
import style from './Navigation.module.scss';

const SubNavUserDetails: FC = () => {
  const { user } = useUserContext();

  return (
    <ComponentWrapper>
      <div className={style.avatar}>
        <Avatar user={user ?? {}} />
        <span>
          {user?.first_name}
          {' '}
          {user?.last_name}
        </span>
      </div>
    </ComponentWrapper>
  );
};
export default SubNavUserDetails;
